import React, { useEffect, useRef, useState } from 'react';
import ViewSlider from './ViewSlider';
import Gridshow from './Gridshow';
import Process from './Process';
import Business from './Business';
import GetInTouch from './GetInTouch';
import GrowingWithClients from './GrowingWithClients';
import { Helmet } from 'react-helmet';
import Service from './Service';
import { FaWhatsapp, FaPhoneAlt, FaArrowUp } from 'react-icons/fa';
import { motion } from 'framer-motion';
import ViewBlogs from './viewblogs';
import { useStateValue } from '../context/StateProvider';
import HomeCaseStudies from './HomeCaseStudies';

const Maincontainer = () => {
  const [loading, setLoading] = useState(true);
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  const [{ Company, Blog }] = useStateValue(); // Access Blog from state
  const scrollRef = useRef(null);
  const [showButtons, setShowButtons] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setShowButtons(false); // Hide buttons on small screens
      } else {
        setShowButtons(true); // Show buttons on larger screens
      }
    };

    handleResize(); // Initial check on load
    window.addEventListener("resize", handleResize); // Listen for window resize

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const autoScroll = setInterval(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
      }
    }, 3000); // Change the interval time as needed (3 seconds in this example)

    return () => clearInterval(autoScroll); // Clean up the interval on unmount
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollToTop(true);
      } else {
        setShowScrollToTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className="w-full h-auto bg-white  flex flex-col items-center justify-center relative"> {/* Added relative */}
      <Helmet>
        <title>Nexify InfoSystems </title>
        <meta
          name="description"
          content="At Nexify InfoSystems, we redefine consulting and staffing with cutting-edge IT solutions in Automation, AI, Data Engineering, Cloud Computing, Cybersecurity, and more. Our bespoke strategies help businesses unlock their full potential."
        />
        <meta
          name="keywords"
          content="Nexify InfoSystems, IT Consulting, Automation, Artificial Intelligence, Data Engineering, Cloud Computing, Cybersecurity, Technology Consulting, Advanced Talent Screening, Digital Transformation, Business Innovation, IT Solutions"
        />
      </Helmet>
      {loading ? (
        <div className="flex items-center justify-center min-h-screen">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
        </div>
      ) : (
        <>
          <ViewSlider />
          <div className="block md:hidden lg:hidden">
            <Gridshow />
          </div>
        <div className="relative w-full max-w-[1400px] mt-10 lg:mt-0 lg:p-0 p-4">
           <div
                      ref={scrollRef}
                      className="lg:w-full flex items-center justify-start lg:justify-center gap-2 lg:gap-28 lg:py-6 overflow-x-auto scrollbar-none md:overflow-x-scroll"
                    >
                      {Company && Company.length > 0 ? (
                        Company.map((brand) => (
                          <motion.div
                            whileHover={{ scale: 1.1 }}
                            key={brand.id}
                            className="flex flex-col items-center bg-white p-2"
                          >
                            <div className="w-24 h-24 md:w-32 md:h-32 lg:w-32 lg:h-32 overflow-hidden">
                              <img
                                src={brand.imageurl}
                                alt={brand.title}
                                className="w-full h-full object-contain"
                              />
                            </div>
                          </motion.div>
                        ))
                      ) : (
                        <p>No Partner available</p>
                      )}
                    </div>
        </div>
          <Process />
          <Business />
          <Service showBanner={false} />
          <GrowingWithClients />
          <HomeCaseStudies/>
          {Blog && Blog.length > 0 && <ViewBlogs showBanner={false} limitBlogs={3} />} {/* Conditionally render ViewBlogs */}
          <GetInTouch />
        </>
      )}

      
 {/* Scroll to Top Button */}
 {showScrollToTop && (
        <button
        onClick={scrollToTop}
        className="fixed lg:bottom-8 bottom-6 left-4 bg-[#00000099]  text-white p-3 rounded-full shadow-lg hover:bg-black transition duration-300 z-50"
      >
        <FaArrowUp size={20} />
      </button>
      
      )}
    </div>
  );
};

export default Maincontainer;